
import useSettings from "app/hooks/useSettings";

export default function NorthernPowerGridLogo({ className }) {
  const { settings } = useSettings();
  const theme = settings.themes[settings.activeTheme];

  return (
    <svg
      width="300px"
      height="80px"
      className={className}
      viewBox="0 0 300 80"
      xmlns="http://www.w3.org/200000000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fill="none" fillRule="evenodd">
        {/* Red Triangle */}
        <polygon fill="#E30613" points="0 0, 80 80, 80 0" />

        {/* Adjusted White Diagonal Lines */}
        <line
          x1="10"
          y1="30"
          x2="80"
          y2="0"
          stroke="white"
          strokeWidth="3"
        />
        <line
          x1="10"
          y1="45"
          x2="80"
          y2="15"
          stroke="white"
          strokeWidth="3"
        />
        <line
          x1="10"
          y1="60"
          x2="80"
          y2="30"
          stroke="white"
          strokeWidth="3"
        />
        <line
          x1="10"
          y1="75"
          x2="80"
          y2="45"
          stroke="white"
          strokeWidth="3"
        />
      </g>
      "NORTHERN"
      <text
        x="90"
        y="35"
        fontFamily="Arial, sans-serif"
        fontSize="30"
        fontWeight="400"
        fill="black"
      >
        NORTHERN
      </text>

      {/* "POWER" Text */}
      <text
        x="90"
        y="65"
        fontFamily="Arial, sans-serif"
        fontSize="30"
        fontWeight="bold"
        fill="#E30613"
      >
        POWER
      </text>

      {/* "GRID" Text */}
      <text
        x="200"
        y="65"
        fontFamily="Arial, sans-serif"
        fontSize="30"
        fontWeight="bold"
        fill="black"
      >
        GRID
      </text>
    </svg>
  );
}
